import BaseComponent from 'foundation/base-component';
import Cookies from 'js-cookie';

export default class BasketBuyLinksComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        const secutixConfigCookie = Cookies.get('secutixConfig');

        if (secutixConfigCookie !== undefined) {
            const secutixConfig = JSON.parse(secutixConfigCookie);

            if (secutixConfig !== undefined) {
                if (this.refs.buyticketsurl !== undefined) {
                    if (secutixConfig.buyTicketsLink === undefined || secutixConfig.buyTicketsLink === '') {
                        this.refs.buyticketsurl.setAttribute('style', 'display:none;');
                    } else {
                        this.refs.buyticketsurl.setAttribute('href', secutixConfig.buyTicketsLink);
                    }
                }

                if (this.refs.buyhospitalityurl !== undefined) {
                    if (secutixConfig.buyHospitalityLink === undefined || secutixConfig.buyHospitalityLink === '') {
                        this.refs.buyhospitalityurl.setAttribute('style', 'display:none;');
                    } else {
                        this.refs.buyhospitalityurl.setAttribute('href', secutixConfig.buyHospitalityLink);
                    }
                }
            }
        }
    }
}
